import { render, staticRenderFns } from "./SettingsMachinePluginsTab.vue?vue&type=template&id=26fe1d60&scoped=true&"
import script from "./SettingsMachinePluginsTab.vue?vue&type=script&lang=js&"
export * from "./SettingsMachinePluginsTab.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMachinePluginsTab.vue?vue&type=style&index=0&id=26fe1d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fe1d60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VIcon,VSimpleTable})
